module.exports = __webpack_public_path__ + "static/media/iconHeaderCCC.c1ec6f1b.png";